export default class LoginClass {
    constructor() {
        this.isLogin=false;
        this.username='';
        this.loginData={};

        this.login().then(()=>{});
    }

    get backendUri(){
        let url = window.location.hostname;
        if(url.includes("test")) {
            return "https://crmtest.blockspingaming.com";
        }
        if (url.includes("localhost")){
            return "http://localhost:5004";
        }
        return 'https://crm.blockspingaming.com';
    }

    async backendLogin(hash=null,loginData=null){
        const body={hash:hash,loginData:loginData};
        const objRet=await this.request(this.backendUri + '/api/login', body);
        return objRet;

        //"#access_token=yYG6I0zEd8dggcBUlf1QxDS6uZJgYKARkSARESFQHGX2MioHZ0--lw7BK24HthZH2LMw0169&token_type=Bearer&expires_in=3599&scope=email%20https://www.googleapis.com/auth/userinfo.email%20openid&authuser=0&prompt=none"
    }

    async checkLoginInHash(){
        const hash = window.location.hash;
        if (hash) {
            const objRet=await this.backendLogin(hash);
            history.replaceState(null,null, ' ');
            //window.location.hash = '';
            if (objRet.success) {
                this.username=objRet.loginData.username;
                let s = JSON.stringify(objRet.loginData);
                localStorage.setItem("loginData", s);
                this.loginData=JSON.parse(s);
            }
            return objRet.success;
        }
        return false;
    }

    async checkLoginInStorage(){
        const s=localStorage.getItem("loginData");
        if (s){
            const loginData=JSON.parse(s);
            const objRet=await this.backendLogin(null,loginData);
            if (objRet.success===true){
                this.username=objRet.loginData.username;
                this.loginData=loginData;
            }
            else{
                localStorage.removeItem("loginData");
            }
            return objRet.success;
        }
        else return false;
    }

    createLoginButton(){
        try {
            this.deleteLoginButton();
            const button = document.createElement('button');
            button.textContent = 'Login';
            button.id = 'loginButton';
            button.style.padding = '10px 20px';
            button.style.fontSize = '16px';
            button.addEventListener('click', () => {
                this.clickLogin();
            });
            document.body.appendChild(button);
            //const elem=document.getElementById('loginButton');
        }
        catch (e) {
            console.log('createLoginButton catch: '+e.message+'\nstack: '+e.stack);
        }
    }

    deleteLoginButton(){
        try {
            const button = document.getElementById('loginButton');
            if (button){
                button.remove();
            }
        }
        catch (e) {
            console.log('deleteLoginButton catch: '+e.message+'\nstack: '+e.stack);
        }
    }

    clickLogin(){
        const clientId='655163482966-9nf6hhaskcog3rq9c1cm5cbbkomvdteo.apps.googleusercontent.com';
        let s=window.location.protocol + "//" + window.location.host;
        if (window.location.host==='localhost:8081'){
            s='http://localhost:8081'
        }
        const redirectUri=encodeURIComponent(s);
        const link = `https://accounts.google.com/o/oauth2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=token&scope=email`;
        //const link=`https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=token&scope=email`;
        window.location.href = link;
    }

    async login(){
        try{
            if (this.isLogin) return;
            this.isLogin=await this.checkLoginInHash();
            if (!this.isLogin) this.isLogin=await this.checkLoginInStorage();
            if (this.isLogin){
                window.location.replace('/')
                //this.createMainScript();
            }
            else {
                this.createLoginButton();
            }
        }
        catch (e) {
            console.log('LoginClass login catch: '+e.message+'\nstack: '+e.stack);
        }
    }

    logout(){
        try {
            if (!this.isLogin) return;
            this.loginData={};
            //this.deleteMainScript()
            //this.deleteDiv();
            //this.createLoginButton();
            const s=localStorage.getItem("loginData");
            if (s) localStorage.removeItem("loginData");
            window.location.replace('/')
        }
        catch (e) {
            console.log('LoginClass login catch: '+e.message+'\nstack: '+e.stack);
        }
    }

    async request(uri, body) {
        const maxTries = 2;
        let tries = 0;

        while(true) {
            try {
                return await this.requestFetch(uri, body);
            } catch(e) {
                if(tries < maxTries && e.message === "Failed to fetch") {
                    tries++;
                    await this.sleep(2000);
                } else {
                    return { error: e.message }
                }
            }
        }
    }
    async requestFetch(uri, body) {
        const response = await fetch(uri, {
            method: 'POST',
            headers: {
                "Content-type": "application/json"
            },
            body: JSON.stringify(body)
        });

        return await response.json();
    }
    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}
